import React from 'react';

const COND_ICONS = {'poisoned':'☠️','stunned':'💫','bleeding':'🩸','frozen':'❄️','burning':'🔥','restrained':'🔗','blessed':'🛡️','hasted':'🔥','shielded':'🫧','raging':'💪'};
const ENEMY_BUFFS = ['blessed','hasted','shielded','raging'];

function EnemyCard({ enemy }) {
  const e = enemy;
  const hpPct = e.max_hp > 0 ? Math.round((e.hp / e.max_hp) * 100) : 0;
  const isDead = e.hp <= 0;
  const conds = Array.isArray(e.conditions) ? e.conditions : (e.conditions || '').split(',').filter(c => c.trim());
  const buffHtml = conds.filter(c => ENEMY_BUFFS.includes(c.trim().toLowerCase())).map(c => (
    <span key={c} title={c.trim()} style={{ fontSize: '0.7rem', cursor: 'help' }}>{COND_ICONS[c.trim().toLowerCase()] || '✨'}</span>
  ));
  const debuffHtml = conds.filter(c => !ENEMY_BUFFS.includes(c.trim().toLowerCase())).map(c => (
    <span key={c} title={c.trim()} style={{ fontSize: '0.7rem', cursor: 'help' }}>{COND_ICONS[c.trim().toLowerCase()] || '⚠️'}</span>
  ));

  return (
    <div className={`enemy-card${isDead ? ' dead' : ''}`}>
      <img src="enemy.jpg" className="enemy-img" alt="enemy" />
      <div className="enemy-info">
        <div className="enemy-name">{e.name} {buffHtml}</div>
        <div className="enemy-bar"><div className="fill hp" style={{ width: `${hpPct}%` }} /></div>
        <div className="enemy-stats"><span>HP {e.hp}/{e.max_hp}</span><span>AC {e.ac}</span></div>
        {debuffHtml.length > 0 && <div className="enemy-conds">{debuffHtml}</div>}
      </div>
    </div>
  );
}

export default function EnemyPanel({ enemies }) {
  const alive = enemies.filter(e => e.hp > 0).length;
  return (
    <div className="enemy-panel" id="enemy-panel">
      <div className="header">{alive > 0 ? `👹 Encounter — ${alive} active` : '👹 Encounter'}</div>
      <div className="enemy-feed" id="enemy-feed">
        {enemies.length === 0 ? (
          <div className="enemy-empty">No active encounter</div>
        ) : (
          enemies.map((e, i) => <EnemyCard key={i} enemy={e} />)
        )}
      </div>
    </div>
  );
}
